import { useCallback } from "react";
import { getDropdownCountryName } from "@/utils/countryMapping";

// Country mappings live in COUNTRY_MAPPINGS (@/utils/countryMapping)
const useCountryMatcher = () => {
  return useCallback((selectedCountryName?: string): string => {
    if (!selectedCountryName) return "";
    return getDropdownCountryName(selectedCountryName);
  }, []);
};

export default useCountryMatcher;
